import { datadogRum } from "@datadog/browser-rum";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

import { ErrorView } from "@ps-design-system/components/ErrorView";

import { AppHeader } from "./components/AppHeader";

const ErrorPage = () => {
  return (
    <>
      <AppHeader />
      <div className="tw-h-screen -tw-mt-72 tw-flex tw-items-center tw-justify-center">
        <ErrorView />
      </div>
    </>
  );
};

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const handleError = (error: unknown, info: React.ErrorInfo) => {
    const renderingError = new Error(
      (error as Error).message || "An unknown error occurred",
    );
    renderingError.name = "ReactRenderingError";
    renderingError.stack = info.componentStack || "";
    renderingError.cause = error;

    datadogRum.addError(renderingError);
  };

  return (
    <ReactErrorBoundary FallbackComponent={ErrorPage} onError={handleError}>
      {children}
    </ReactErrorBoundary>
  );
};

export { ErrorBoundary };
